module.exports = __webpack_public_path__ + "static/pay-by-link-atelier-animation-es-33be24ea81a8ccab399cfd5ac539655c.mp4";